import * as React from 'react';
import * as classnames from 'classnames';

interface GridProps {
	className?: string;
	vertical?: boolean;
}
export const Grid: React.SFC<GridProps> = ({children, className, vertical}) => {
	return (
		<div
			className={classnames('slds-grid', className, {
				'slds-grid_vertical': vertical
			})}
		>
			{children}
		</div>
	);
};

interface ColProps {
	className?: string;
	size?: string;
}
export const Col: React.SFC<ColProps> = ({children, className, size}) => {
	const sizeClass = size ? `slds-size_${size}` : null;
	return (
		<div className={classnames(className, 'slds-col', sizeClass)}>{children}</div>
	);
};



// WEBPACK FOOTER //
// ./src/lib/grid.tsx